export default "__VITE_ASSET__ggYytIX0__"